import { IoWarning } from "react-icons/io5";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { Button } from "@/pages/quiz/15000/components/Button";

const ErrorScreen = ({ question, onBack }: QuizQuestionProps<boolean>) => {
  const { title, message, customHTML } = question.attributes || {};

  return (
    <>
      <div className="flex flex-col justify-center gap-5">
        <h2 className="text-xl sm:text-3xl lg:text-4xl text-dark-purple font-bold text-center">
          {title}
        </h2>
        <div className="text-lg sm:text-xl lg:text-2xl px-4 sm:px-6 py-7 flex gap-3 flex-col items-center bg-peach-puff rounded-xl font-normal text-black text-center">
          <div>
            <IoWarning className="w-12 sm:w-20 lg:w-24 h-12 sm:h-20 lg:h-24 text-tomato" />
          </div>

          {message && <p>{message}</p>}

          {customHTML && (
            <div
              className="quiz-description"
              dangerouslySetInnerHTML={{ __html: customHTML }}
            />
          )}
        </div>
      </div>

      <Button
        onClick={onBack}
        showNextIcon={false}
        className="bg-brick-red hover:bg-brick-red/80"
      >
        Back
      </Button>
    </>
  );
};

export { ErrorScreen };
